import React, { useState } from 'react';
import styled from 'styled-components';
import { Grid, Color } from '../app/StyleGuide';

interface Props {
  src?: string;
  size?: string;
}

const CircularProfileImage = styled.img<Props>`
  border-radius: 50%;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
  width: ${props => props.size};
  height: ${props => props.size};
  object-fit: cover;
`;

const DefaultProfileImage = styled.span.attrs({
  className: 'fas fa-user-circle',
})<Props>`
  font-size: ${props => props.size};
  width: ${props => props.size};
  height: ${props => props.size};
  color: ${Color.Blue._15};
`;

export default function ProfileImage({ src, size = Grid._7 }: Props) {
  const [error, setError] = useState(false);

  return src && !error ? (
    <CircularProfileImage src={src} size={size} onError={() => setError(true)} />
  ) : (
    <DefaultProfileImage size={size} />
  );
}
